"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Configure = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5Z",
        fill: "url(#paint0_linear_7581_39366)",
        fillOpacity: 0.4
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M17.2774 19.3879L18.9384 17.764C19.0571 17.648 19.1173 17.5118 19.1191 17.3554C19.1208 17.199 19.0637 17.0614 18.9477 16.9428L15.3676 13.219C15.4482 13.0048 15.5093 12.7904 15.5508 12.5757C15.5924 12.3611 15.6147 12.1169 15.6178 11.8431C15.6304 10.7286 15.2452 9.77089 14.4622 8.97003C13.6792 8.16918 12.7305 7.76246 11.616 7.74987C11.2836 7.74612 10.9506 7.78636 10.6172 7.87059C10.2838 7.95483 9.95984 8.07339 9.64522 8.22628L12.3711 11.0144L10.7101 12.6384L7.98419 9.85021C7.82423 10.1613 7.69838 10.4825 7.60663 10.814C7.51489 11.1454 7.46714 11.4773 7.46339 11.8097C7.4508 12.9242 7.83599 13.8819 8.61895 14.6828C9.40191 15.4836 10.3507 15.8903 11.4652 15.9029C11.7194 15.9058 11.9591 15.889 12.1844 15.8524C12.4098 15.8158 12.6304 15.7596 12.8464 15.6839L16.4562 19.3787C16.5722 19.4973 16.7084 19.5575 16.8648 19.5593C17.0212 19.561 17.1588 19.5039 17.2774 19.3879Z",
        fill: "#8790A6"
      }
    ),
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
      "linearGradient",
      {
        id: "paint0_linear_7581_39366",
        x1: 2.58902,
        y1: 17.556,
        x2: 14.2159,
        y2: 20.5295,
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement("stop", { stopColor: "#C3C7D3" }),
      /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#C3C7D3", stopOpacity: 0 })
    ))
  );
};
export default Configure;
